'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputGroup = require('./InputGroup');

Object.defineProperty(exports, 'InputGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/inputGroup/index.js
// module id = 563
// module chunks = 0